import { computed } from 'vue'
import jalaliMoment from 'jalali-moment'
import { useI18n } from 'vue-i18n'

export function useFormattedNearestTime() {
  const { locale } = useI18n() // Get the current locale from Vue I18n

  const getFormattedDate = (timestamp) => {
    const currentDate = new Date()
    const date = new Date(timestamp)
    const jalaliDate = jalaliMoment(date)

    const currentLocale = locale.value || 'en' // Default to 'en'

    if (isSameDay(currentDate, date)) {
      return currentLocale === 'fa'
        ? `${jalaliDate.locale('fa').format('HH:mm')}`
        : `${jalaliDate.format('HH:mm')}`
    } else if (isYesterday(currentDate, date)) {
      return currentLocale === 'fa'
        ? `دیروز ${jalaliDate.locale('fa').format('HH:mm')}`
        : `Yesterday ${jalaliDate.format('HH:mm')}`
    } else if (isSameWeek(currentDate, date)) {
      return currentLocale === 'fa'
        ? `${jalaliDate.locale('fa').format('dddd HH:mm')}`
        : `${jalaliDate.format('dddd HH:mm')}`
    } else {
      return currentLocale === 'fa'
        ? jalaliDate.locale('fa').format('HH:mm - jYYYY/jMM/jDD')
        : jalaliDate.format('YYYY/MM/DD - HH:mm')
    }
  }

  return { getFormattedDate }
}

// Helper functions
const isSameDay = (date1, date2) => {
  return (
    date1.getDate() === date2.getDate() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getFullYear() === date2.getFullYear()
  )
}

const isYesterday = (date1, date2) => {
  const yesterday = new Date(date1)
  yesterday.setDate(date1.getDate() - 1)
  return isSameDay(yesterday, date2)
}

const isSameWeek = (date1, date2) => {
  const oneDayMilliseconds = 24 * 60 * 60 * 1000
  const diffInDays = Math.abs((date1 - date2) / oneDayMilliseconds)
  return diffInDays < 7 // Less than 7 days difference
}
